export const regexRules = {
  condominium: [
    /(^casa[s]?($|\s?\d+)|casa\s(da|do|de|n°|alameda|rua|avenida))$/i,
    /(^resid[e|ê]ncia[s]?$)|(resid[e|ê]ncia\s(da|do))/i,
    /^(\D)?\s?\d+$/i,
    /^nenhum[a]?$/i,
    /^\d{3}$/i,
    /^(.)\1\1/i,
    /nada consta/i,
    /possui/i,
    /a placa foi instalada/i,
    // eslint-disable-next-line no-useless-escape
    /^[,.\-_;*\/(]+|[,.\-_;*\/(]+$/i,
    /\bnao informado\b|\bnão informado\b|\bsem nome\b|\bsem\b|\bnão.*|\bnao.*|^nome do\b/i,
  ],
};

export const isInvalidNames = (value, type) => regexRules[type || 'condominium'].filter((regex) =>
  regex.test(value)).length > 0;
